var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"msr z-index-3",class:_vm.$desktopModeStyles,style:({
      'margin-bottom':
        (_vm.adaptToSmallScreen && _vm.$vuetify.breakpoint.xs ? 64 : 48) + 'px',
    }),attrs:{"fab":_vm.adaptToSmallScreen && _vm.$vuetify.breakpoint.xs,"round":!_vm.adaptToSmallScreen || _vm.$vuetify.breakpoint.smAndUp,"dark":"","fixed":"","bottom":"","right":""},on:{"click":function($event){$event.stopPropagation();_vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":!_vm.adaptToSmallScreen || _vm.$vuetify.breakpoint.smAndUp}},[_vm._v("\n      textsms\n    ")]),_vm._v(" "),(!_vm.adaptToSmallScreen || _vm.$vuetify.breakpoint.smAndUp)?_c('span',[_vm._v(_vm._s(_vm.$t('createTicker')))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CreateTickerButton.vue?vue&type=template&id=41bb0fa0&
// module id = 2121
// module chunks = 5